import {
  postData,
  showAlert,
  setFormProcessing,
  trimValues,
  getFormDataAsObject,
} from "../util";

document.addEventListener("DOMContentLoaded", () => {
  document.getElementById("email")?.focus();

  const signInForm = document.getElementById("signin-form");
  signInForm?.addEventListener("submit", async (e) => {
    e.preventDefault();

    const data = trimValues(getFormDataAsObject(signInForm));
    setFormProcessing(signInForm, true);

    try {
      const res = await postData("/api/company/signin", data);

      if (res && res.body.success) {
        await showAlert({
          icon: "success",
          text: "Έχετε συνδεθεί επιτυχώς.",
          isToast: true,
          toastOptions: {
            timer: 1000,
          },
        });
        window.location.replace(res.body.redirectUrl || "/");
      } else {
        await showAlert({
          icon: "error",
          text: res.body.error || "Λάθος στοιχεία σύνδεσης.",
        });
      }
    } catch (error) {
      console.error("Sign-In Error:", error);
      await showAlert({
        icon: "error",
        text: "Κάτι πήγε στραβά.",
      });
    } finally {
      setFormProcessing(signInForm, false);
    }
  });
});
